module.exports = __webpack_public_path__ + "static/media/gtz-logo.17c26b97.svg";